export const BaseInputStyle = 'w-full border border-mediumGrey py-2.5 px-3 rounded'
export const InputWrapperStyle = 'relative flex'
export const BaseCheckboxRadioStyle = 'relative flex items-center'
